<template>
  <div class="header-container">
    <!-- 左侧：Logo -->
    <div class="header-left" @click="navigateToProduct('/home')">
      <img src="@/assets/logo.png" alt="Logo" style="width: 200px;"/>
    </div>

    <!-- 中间：导航菜单 -->
    <ul class="header-menu">
      <li v-for="(item, index) in menuItems" :key="index" 
          :class="{ 'active': isActive(index), 'menu-item': true }"
          @mouseenter="handleMouseEnter(index)" 
          @mouseleave="handleMouseLeave"
          @click="handleMenuClick(index)">
        {{ item }}

        <!-- 只为前三个菜单项显示下拉菜单 -->
        <div v-if="index < 3 && showProductDropdown && showIndex === index" 
             class="product-dropdown"
             @mouseenter="cancelCloseTimer"
             @mouseleave="handleMouseLeave">
          <div class="product-dropdown-container">
            <!-- 左侧区域 -->
            <div class="left-section">
              <!-- 标题区域 -->
              <div class="product-title-wrapper">
                <div class="product-title">{{ products[showIndex].title }}</div>
              </div>

              <!-- 产品列表区域 -->
              <div class="product-grid-wrapper">
                <div class="product-grid">
                  <div v-for="(product, pIndex) in products[showIndex].data" :key="pIndex" class="product-item"
                    @click.stop="navigateToProduct(product.route)">
                    {{ product.name }}
                  </div>
                </div>
              </div>
            </div>

            <!-- 右侧：宣传大图 -->
            <div class="promotion-area">
              <img src="@/assets/images/组 1206@1x.png" alt="看看数字化榜样" class="promotion-image" />
            </div>
          </div>
        </div>
      </li>
    </ul>

    <!-- 右侧：联系按钮 -->
    <div class="header-right">
      <a-button type="primary" @click="navigateToProduct('/contactUs')" >联系我们</a-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HeaderComponent',
  data() {
    return {
      menuItems: ['安全教培产品', '安全生产产品', '安全监测产品', '行业案例', '关于我们'],
      showProductDropdown: false,
      showIndex: 0,
      closeTimer: null,
      products: [
        {
          title: '安全教培产品',
          data: [
            { name: '智培云平台', route: '/zhipaiyun' },
            { name: '数字沙盘教学系统', route: '/shuzhisandpan' },
            { name: 'VR培训系统', route: '/vrtraining' },
            { name: 'MR数播系统', route: '/mrshubosystem' },
            { name: '裸眼3D模拟系统', route: '/naked3d' },
            { name: '情景化培训系统', route: '/qingjinghua' },
            { name: '仿真故障模拟器', route: '/faultsimulator' },
            { name: '远程设备运维系统', route: '/remoteoperation' },
            { name: '数字化展厅', route: '/digitalhall' }
          ]
        },
        {
          title: '安全生产产品',
          data: [
            { name: '煤矿采掘全域孪生综合解决方案', route: '/meikuangcaijuequanyuruanshengzhonghe' },
            { name: '数字沙盘推演系统', route: '/shuzishanpan' },
          ]
        },
        {
          title: '安全监测产品',
          data: [
            { name: '边波智能监测和预警系统', route: '/bianbozhinengjianceheyujing' },
            { name: '多源监测数据"预訾树"系统', route: '/duoyuanjianceshuju' },
            { name: '分布式光纤监测与智能预警', route: '/fenbushiguanqianjiance' },
            { name: '瓦斯抽采智能监控平台', route: '/wasichoucaizhinengjiankong' },
            { name: 'AR燃气智能巡检系统', route: '/ARranqizhinengxunjian' },
          ]
        },
      ],
      simpleRoutes: {
        3: '/hangyeanli', // 行业案例路由
        4: '/guanyuwomen'        // 关于我们路由
      }
    };
  },
  methods: {
    isActive() {
      // 简单激活状态判断，可根据路由调整
      return this.$route.name === 'home';
    },

    handleMouseEnter(index) {
      // 清除之前的关闭定时器
      if (this.closeTimer) {
        clearTimeout(this.closeTimer);
        this.closeTimer = null;
      }

      // 只为前三个菜单项显示下拉菜单
      if (index < 3) {
        this.showIndex = index;
        this.showProductDropdown = true;
      }
    },

    handleMouseLeave() {
      // 设置延迟关闭，防止鼠标移动到下拉菜单时立即关闭
      this.closeTimer = setTimeout(() => {
        this.showProductDropdown = false;
      }, 300);
    },

    cancelCloseTimer() {
      // 当鼠标移动到下拉菜单时取消关闭定时器
      if (this.closeTimer) {
        clearTimeout(this.closeTimer);
        this.closeTimer = null;
      }
    },

    handleMenuClick(index) {
      // 第4和第5个菜单项（行业案例和关于我们）直接跳转
      if (index >= 3 && index <= 4) {
        const route = this.simpleRoutes[index];
        if (route) {
          this.navigateToProduct(route);
        }
      } else {
        // 前三个菜单项点击切换下拉菜单显示状态
        if (this.showIndex === index && this.showProductDropdown) {
          this.showProductDropdown = false;
        } else {
          this.showIndex = index;
          this.showProductDropdown = true;
        }
      }
    },

    navigateToProduct(route) {
      this.$router.push(route);
    }
  },

  beforeUnmount() {
    // 组件销毁前清除定时器
    if (this.closeTimer) {
      clearTimeout(this.closeTimer);
    }
  }
};
</script>

<style scoped>
.header-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 70px;
  padding: 0 3%;
  font-size: 14px;
  font-weight: bold;
  position: relative;
  z-index: 100;
  min-width: 100%;
  background-color: white;
}

.header-left {
  display: flex;
  align-items: center;
}

.logo {
  width: 30px;
  height: 30px;
  margin-right: 10px;
}

.title {
  font-size: 20px;
  font-weight: bold;
  white-space: nowrap;
}

.header-menu {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
  flex: 1;
  justify-content: center;
}

.header-menu li {
  margin: 0 2%;
  cursor: pointer;
  position: relative;
  font-size: 0.9rem;
  font-weight: normal;
  white-space: nowrap;
}

.header-menu li.active {
  font-weight: bold;
}

/* 下拉菜单样式 */
.product-dropdown {
  position: fixed;
  top: 4rem;
  left: 50%;
  transform: translateX(-50%);
  background: linear-gradient(180deg, #FFFFFF 0%, #EEF2FF 100%);
  border: 1px solid #ddd;
  padding: 2rem 0;
  z-index: 1000;
  width: 100vw;
  box-sizing: border-box;
  height: 30vh;
  overflow: hidden;
}

.product-dropdown-container {
  display: flex;
  flex-direction: row;
  gap: 20px;
  padding: 0px 10rem;
  height: 100%;
}

.left-section {
  flex: 3;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.product-title-wrapper {
  width: 100%;
}

.product-title {
  font-size: 1.2rem;
  font-weight: bold;
  color: #333;
  margin: 0;
  padding: 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  padding-bottom: 5px;
  text-align: left;
}

.product-grid-wrapper {
  flex: 1;
  overflow-y: auto;
}

.product-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  width: 100%;
}

.product-item {
  padding: 8px 0;
  cursor: pointer;
  transition: all 0.3s ease;
  color: #333;
  text-align: left;
}

.product-item:hover {
  color: #007bff;
  background-color: #f8f9fa;
}

.promotion-area {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  /* padding: 20px; */
}

.promotion-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
}
</style>